import $ from 'jquery';
$(document).ready(function () {
    var status = $('.pagingInfo');
    var slickElement = $('.image-slider-block .playlist-slider');
    var autoPlayElement = document.querySelector('.image-slider-block');
    var element = autoPlayElement === null || autoPlayElement === void 0 ? void 0 : autoPlayElement.dataset.autoplay;
    var flag = (element === "true") ? true : false;
    slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        status.text(i + '/' + slick.slideCount);
    });
    $('.image-slider-block .playlist-slider').slick({
        centerMode: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: flag,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
        ]
    });
});
